module.exports = __webpack_public_path__ + "img/bs-8.1c2f017a.jpg";